<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      :contentStyle="{'height':'100%','overflow': 'hidden'}"
      size="table1400"
      notFooterPadding
      @open="modalOpen"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      <span>添加批次</span>
    </template>
    <template #content>
      <app-base-main
          :table-shadow="false"
          :no-padding="true"
          parentTable
          >
        <template #filter-group>
          <app-filter-group
              @reset="$gjReset"
              @query="$gjNoticeQuery">
            <gj-warehouse-select
                v-model="filter.warehouseIds"
                multiple
                :self="false"
                placeholder="仓库"
                width="165px"
            ></gj-warehouse-select>
            <gj-select-input
                v-model="filter.keyword"
                :options="keywordOptions"
                :width="['100px', '150px']"
            ></gj-select-input>
          </app-filter-group>
        </template>
        <template #table>
          <gj-table
              ref="gjTable"
              adaptParent
              :index="false"
              name="printProductLabel"
              :loading="loading"
              :data="tableData"
              :columns="columns"
              :offset-height="130"
              selection
              :pagination="pagination"
              @sort-change="$gjSortChange"
              @page-change="$gjNoticeQuery">
          </gj-table>
        </template>
      </app-base-main>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, queryMixin, selectionMixin} from "@/minxins";
  import {defaultVal, isMeaningful} from "@/utils/common";
  import { storageCostBatchAddBatchPage } from "@/api/finance";
  import BigNumber from 'bignumber.js';

  export default {
    name: "app-add-product-modal",
    mixins: [modalMixIn, queryMixin, selectionMixin],
    props: {
      excludeId: {
        type: Array,
        default: () => []
      }
    },
    created() {
    },
    data() {
      return {
        tableData: [],
        keywordOptions: [
          {id: 'shipmentId', text: '货件号'},
          {id: 'msku', text: 'MSKU'},
          {id: 'batchNumber', text: '批次号'},
        ],
        columns: [
          { id: 'warehouseName', header: '仓库', field: 'warehouseName', minWidth: '120px', },
          { id: 'batchNumber', header: '批次号', field: 'batchNumber', minWidth: '145px', },
          {id: 'picture', header: '图片', field: 'picture:imageUrl', width: '60px',},
          { id: 'msku', header: 'MSKU', field: 'msku', minWidth: '170px' ,},
          { id: 'marketDate', header: '入库日期(站点时区)', field: 'marketDate', minWidth: '130px' },
          { id: 'shipmentId', header: '货件号', field: 'shipmentId', minWidth: '170px' },
          { id: 'receiptQuantity', header: '数量', summary:true, field: 'receiptQuantity', minWidth: '125px', default: true},
        ],
        filter: {
          warehouseIds: null,
          keyword: {
            key: 'shipmentId',
            value: null
          },
        },
      }
    },
    methods: {
      $gjQueryInitParams() {
        return {
          filter: {
            warehouseIds: null,
            keyword: {
              key: 'shipmentId',
              value: null
            },
          },
        };
      },
      $gjQuery() {
        // 构造查询参数
        const params = {
          model: {
            excludeId: this.excludeId,
            warehouseIdList: this.filter.warehouseIds
          },
          ...this.queryPagination,
          ...this.querySort
        };
        params.model[this.filter.keyword.key] = this.filter.keyword.value;
        // 查询
        this.loading = true;
        storageCostBatchAddBatchPage(params)
          .then((data) => {
            data.records = data.records || []
            data.records.forEach(item => {
              item.purchaseCost = this._.round(item.purchaseCost, 4);
              item.arrivalCost = this._.round(item.arrivalCost, 4);
              item.purchaseCostTotal = new BigNumber(item.purchaseCost).times(item.receiptQuantity).decimalPlaces(4) + '';
              item.arrivalCostTotal = new BigNumber(item.arrivalCost).times(item.receiptQuantity).decimalPlaces(4) + '';
            });
            this.tableData = data.records || [];
            this.pagination = this.getPagination(data);
          })
          .complete(() => {
            this.loading = false;
          });
      },
      confirm() {
        if (this.selectedRows.length === 0) {
          this.$gjMessage.error('请勾选批次');
          return;
        }
        this.$emit('select', this.selectedRows);
        this.$gjDestroy();
      }
    }
  }
</script>

<style scoped lang="scss">
  .add-product-btn {
    margin: 5px 0 10px;
  }
  ///deep/.gj-modal--footer .el-dialog__footer{
  //  padding-top: 0;
  //}
  // /deep/ .table{
  //   padding-bottom: 1px;
  // }
</style>
